// ─────────────────────────────────────────────────────────────────────────
// `/challenge/brain-starter`: the free Brain Starter prompt from the challenge
// waitlist's confirmation email, on its own page so it can be linked and
// copied on a phone. Dispatched by `MarketingV2App` like `/challenge`, and
// kept out of `challenge/` so the sales page's folder stays untouched.
//
//   /challenge/brain-starter     the page
//   ?view=brain-starter          local dev, from the default surface
// ─────────────────────────────────────────────────────────────────────────

import { BRAIN_STARTER_PATH } from '../../../../../shared/challengeBrainStarter';

export { BRAIN_STARTER_PATH };

/** Cheap and total: called before the marketing surface renders anything. */
export function isBrainStarterPath(pathname: string, search = ''): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === BRAIN_STARTER_PATH) return true;
  return new URLSearchParams(search).get('view') === 'brain-starter';
}
